// extracted by mini-css-extract-plugin
export default {"container":"delivery-method_container__f6n9u","title":"delivery-method_title__of0dP","options":"delivery-method_options__3vl2e"};